getImgUrl = (image) => {
  const images = require.context("../../assets/", false, /\.svg$/);
  return images("./" + image);
}
